/*
 * @Description: 
 * @Version: 1.0
 * @Autor: zhangle
 * @Date: 2022-03-16 13:43:35
 * @LastEditors: zhangle
 * @LastEditTime: 2023-04-23 14:45:47
 */
import TsaLoading from '@/components/Loading/index.vue'
let $vm
const plugin = {
  install (vue, pluginOptions = {}) {
    const Loading = vue.extend(TsaLoading)
    if (!$vm) {
      $vm = new Loading({
        el: document.createElement('div')
      })
      document.body.appendChild($vm.$el)
    }

    const loading = {
      show (options = {}) {
        $vm.show = true
        $vm.text = options.text || '加载中'
      },
      hide () {
        $vm.show = false
      }
    }
    if (!vue.prototype.$TsaLoading) {
      vue.prototype.$TsaLoading = loading
    }
  }
}

export default plugin



// WEBPACK FOOTER //
// ./src/plugins/Loading/index.js